import { Row, Col } from "react-bootstrap";

const LoginMobile = ({ handleSubmit, email, setEmail, status }) => {

    return (
        <>
            <Row style={{ paddingTop: "20px", overflow:"hidden" }}>
                <Col xs={1} md={2}></Col>
                <Col xs={10} md={8} className="text-center primary-font-color">
                        
                    <Row className="mx-auto" style={{ paddingTop: "60px", fontSize:"2rem", lineHeight: "1.2", maxWidth: "400px", margin: "0 auto" }}>
                        <div style={{ textAlign: "left", width: "100%", padding:"0px" }}>Login</div>
                    </Row>
                    <Row className="mx-auto" style={{ paddingTop: "10px", fontSize:"1rem", lineHeight: "1.4", maxWidth: "400px", margin: "0 auto" }}>
                        <div style={{ textAlign: "left", width: "100%", padding:"0px" }}>Please use the specific email Elliot has granted access. Not everyone needs to login.</div>
                    </Row>
                    <Row style={{ paddingTop: "40px" }}>
                        <Col>                            
                            <button type="button" 
                                className="btn btn-lg btn-outline-success mt-2 mx-auto d-block d-flex align-items-center justify-content-center" 
                                style={{
                                    width: "100%", 
                                    maxWidth: "400px",
                                    backgroundColor:"#ffffff", 
                                    color:"#000000AA", 
                                    border: "1px solid #ccc", 
                                    fontWeight:"400", 
                                    height:"50px",
                                    borderRadius: "0.375rem"
                                }}
                                onClick={() => window.location.href = '/auth/google'}
                            >                                    
                            <img
                                src="https://developers.google.com/identity/images/g-logo.png"
                                alt="Google logo"
                                className="me-2"
                                style={{ width: "20px", height: "20px" }}
                            />
                            Sign in with Google</button>
                        </Col>            
                    </Row>
                    <div style={{ display: "flex", alignItems: "center", margin: "20px auto", maxWidth: "400px" }}>
                        <hr style={{ flex: 1, border: "none", borderTop: "1px solid #666" }} />
                        <span style={{ margin: "0 10px", color: "#666" }}>OR</span>
                        <hr style={{ flex: 1, border: "none", borderTop: "1px solid #666" }} />
                    </div>
                    <Row>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group" style={{display: "flex", flexDirection: "column", alignItems: "center"}}>                            
                            <div style={{position:"relative", width: "100%", maxWidth: "400px"}}>
                                <input
                                    className="form-control"
                                    type="email"
                                    id="email"
                                    name="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    style={{ 
                                        height: "50px", 
                                        border: "1px solid #ccc", 
                                        outline: "none", 
                                        color: "#000000AA", 
                                        backgroundColor: "#ffffff",
                                        borderRadius: "0.375rem",
                                        paddingLeft: "12px",
                                        paddingRight: "12px"
                                    }}
                                />
                            </div>
                            <button type="submit" className="btn btn-lg btn-success mt-2" style={{
                                width: "100%", 
                                maxWidth: "400px", 
                                backgroundColor:"#067100", 
                                border: "1px solid #ccc",
                                height:"50px",
                                fontSize:"1rem"
                            }}>Sign in</button>
                            <p className="mt-4">{status}</p>
                        </div>
                    </form>
                    </Row>
                </Col>
                <Col xs={1} md={2}></Col>                            
            </Row>
        </>
    );
}

export default LoginMobile;